import { useContext } from 'react'

import { useSelector } from 'react-redux'

import UploadToFacebookAdsManager from '@components/Licensing/UploadToFacebookAdsManager'
import { CurrentMediaObjectIdContext } from '@context/CurrentMediaObjectId'
import { IApplicationState } from '@store'
import { selectMediaObjectIsUploadedToFacebookAds } from '@store/mediaObjects'

interface IProps {
  mediaObjectId: number
}

const MediaObjectLicensingLicensedUploadToFacebookAdsManager = ({ mediaObjectId }: IProps) => {
  const { setCurrentMediaObjectId } = useContext(CurrentMediaObjectIdContext)
  const isUploadedToFacebookAds = useSelector((state: IApplicationState) =>
    selectMediaObjectIsUploadedToFacebookAds(state, mediaObjectId),
  )

  const onBeforeUpload = () => {
    setCurrentMediaObjectId(mediaObjectId)
  }

  return (
    <UploadToFacebookAdsManager
      isUploadedToFacebookAds={isUploadedToFacebookAds}
      onBeforeUpload={onBeforeUpload}
    />
  )
}

export { MediaObjectLicensingLicensedUploadToFacebookAdsManager }
export default MediaObjectLicensingLicensedUploadToFacebookAdsManager
